import React, { useState } from "react";
import { Formik, Field, Form } from "formik";
import { toast } from "react-toastify";
import { MdClose, MdEdit } from "react-icons/md";
import tw from "tailwind-styled-components";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    SelectionCard,
    Wrapper,
    CombineInputGroup,
    ActionSection,
    ScrollableContent,
    RupeeIcon,
} from "../Styles/InputStyles";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { FaPlus } from "react-icons/fa";

const SelectPackage = ({
    handleClose,
    setEditPackage,
    selectPackage,
    setPackageData,
    addOptionMutate,
    addOptionLoading,
    setIsCreatingNew,
    isCreatingNew,
    selectedData,
    addSelectMutate,
    addSelectLoading,
    propId,
    security
}) => {
    const selectProperty = useSelector(
        (state) => state.SelectPropertyReducer.selectProperty
    );
    const user = useSelector((state) => state.UserReducer.user);
    // const propId = selectProperty.id;

    const [selectedType, setSelectedType] = useState("");

    const roomOptionListing = async () => {
        if (!selectedType) return;
        return await axios.get(
            `${Config.apiUrl}/room/option/list/${propId}/${selectedType}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${user.token}`,
                },
            }
        );
    };

    const { isLoading, error, data, refetch } = useQuery(
        ["roomOptionListing", propId, selectedType],
        roomOptionListing,
        { enabled: !!selectedType }
    );

    const initialValues = {
        title: "",
        amenities: [],
        type: "",
        rent: "",
        security: security || "",
        noOfBeds: "",
        selectPackage: "",
        selectType: "",
    };

    const amenities = [
        { value: "AC", label: "AC" },
        { value: "TV", label: "TV" },
        { value: "Attached Bathroom", label: "Attached Bathroom" },
        { value: "Balcony", label: "Balcony" },
        { value: "Wi-Fi", label: "Wi-Fi" },
        { value: "Washing Machine", label: "Washing Machine" },
        { value: "Cooler", label: "Cooler" },
        { value: "Geyser", label: "Geyser" },
    ];

    const sharingTypes = [
        { value: 1, label: "Single Sharing" },
        { value: 2, label: "Double Sharing" },
        { value: 3, label: "Triple Sharing" },
        { value: 4, label: "3+ Sharing" },
    ];

    const handleSubmit = (values, { resetForm }) => {
        if (!isCreatingNew) {
            if (!values.selectPackage) {
                toast.error("Please select a package to move forward");
                return;
            }
            addSelectMutate({
                roomOptionId: values.selectPackage,
                rooms: Array.isArray(selectedData.id)
                    ? selectedData.id
                    : [selectedData.id],
            });
            return;
        }

        const amountRegex = /^(?!0+$)\d{4,6}$/;
        const maxAmount = 1000000;
        const titleRegex = /^(?=.*[A-Za-z0-9])[A-Za-z0-9 ]{5,}$/;
        const maxSecurityAmount = 1000000;

        if (!values.title || !values.type || values.amenities.length === 0) {
            toast.error("All Fields are required");
            return;
        }
        if (!titleRegex.test(values.title)) {
            toast.error(
                "Title must be at least 5 characters long and can contain alphabets and numbers"
            );
            return;
        }

        if (!amountRegex.test(values.rent) || parseInt(values.rent) > maxAmount) {
            toast.error(
                "Monthly rent must be between 1000 and 10,00,000 and contain only numbers"
            );
            return;
        }
        if (values.security && values.security !== "") {
            const securityAmount = parseInt(values.security);
            if (isNaN(securityAmount) || securityAmount <= 0) {
                toast.error("Security deposit must be a positive number");
                return;
            }
            if (securityAmount > maxSecurityAmount) {
                toast.error(`Security deposit cannot exceed ₹${maxSecurityAmount.toLocaleString()}`);
                return;
            }
        }
        if (
            values.type === 4 &&
            (!values.noOfBeds || values.noOfBeds < 4 || values.noOfBeds > 12)
        ) {
            toast.error("No. of beds should be between 4 to 12");
            return;
        }
        addOptionMutate({
            name: values.title,
            rent: values.rent,
            security: values.security || 0,
            type: values.type,
            amenities: values.amenities.join(","),
            propId: propId,
            totalBedCount:
                values.type === 1
                    ? 1
                    : values.type === 2
                        ? 2
                        : values.type === 3
                            ? 3
                            : parseInt(values.noOfBeds),
        },
            {
                onSuccess: () => {
                    refetch()
                    resetForm()
                },
            },);
    };

    const handleEditClick = (selectedPackageValue) => {
        const selectedPackage = data?.data?.data?.find(
            (pkg) => pkg.id === parseInt(selectedPackageValue)
        );

        if (selectedPackage) {
            setEditPackage(true);
            setPackageData(selectedPackage);
            handleClose();
        }
    };

    return (
        <Container>
            <Header>
                <h1 className="text-white text-lg font-medium">
                    Select/Create Bed Option
                </h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                    {({ values, setFieldValue, resetForm }) => (
                        <Form>
                            <ScrollableContent className="max-h-[calc(100dvh-120px)]">
                                <Wrapper>
                                    {!isCreatingNew && (
                                        <>
                                            <InputGroup>
                                                <Label>Select Type *</Label>
                                                <Select
                                                    id="type"
                                                    name="type"
                                                    value={values.type}
                                                    onChange={(e) => {
                                                        setFieldValue("type", e.target.value);
                                                        setFieldValue("selectPackage", "");
                                                        setSelectedType(e.target.value);
                                                    }}
                                                    className="px-2"
                                                    required
                                                    style={{ height: "46px" }}
                                                >
                                                    <MenuItem value="" disabled>
                                                        Select Type
                                                    </MenuItem>
                                                    {sharingTypes?.map((typeOption) => (
                                                        <MenuItem
                                                            key={typeOption.value}
                                                            value={typeOption.value}
                                                        >
                                                            {typeOption.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </InputGroup>

                                            {data && data?.data?.data === false && !isCreatingNew && (
                                                <div className="flex flex-1 justify-center items-center text-center px-4 my-16">
                                                    <div>
                                                        <p className="py-2">No Package Found</p>
                                                        <AddPackageBtn
                                                            onClick={() => setIsCreatingNew(true)}
                                                            className="px-4 flex"
                                                        >
                                                            <FaPlus className="mr-2" /> Add Package
                                                        </AddPackageBtn>
                                                    </div>
                                                </div>
                                            )}

                                            {values.type && data && data?.data?.data !== false && (
                                                <InputGroup>
                                                    <Label>Select Package *</Label>
                                                    <Select
                                                        id="selectPackage"
                                                        name="selectPackage"
                                                        value={values.selectPackage}
                                                        onChange={(e) =>
                                                            setFieldValue("selectPackage", e.target.value)
                                                        }
                                                        className="px-2"
                                                        required
                                                        style={{ height: "46px" }}
                                                    >
                                                        <MenuItem value="" disabled>
                                                            Select Package
                                                        </MenuItem>
                                                        {data?.data?.data?.map((pkg) => (
                                                            <MenuItem key={pkg.id} value={pkg.id}>
                                                                {pkg.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </InputGroup>
                                            )}
                                        </>
                                    )}

                                    {values.selectPackage && !isCreatingNew && (
                                        <CardContainer>
                                            <div className="flex justify-between mb-2">
                                                <CardTitle>
                                                    {
                                                        data?.data?.data?.find(
                                                            (pkg) => pkg.id === parseInt(values.selectPackage)
                                                        )?.name
                                                    }
                                                </CardTitle>
                                                <EditButton
                                                    type="button"
                                                    onClick={() => handleEditClick(values.selectPackage)}
                                                >
                                                    <MdEdit className="mr-1" size={12} />
                                                    Edit
                                                </EditButton>
                                            </div>
                                            <CardDetailsList>
                                                <CardDetailItem>
                                                    <DetailLabel>Amenities:</DetailLabel>
                                                    <DetailValue>
                                                        {
                                                            data?.data?.data?.find(
                                                                (pkg) =>
                                                                    pkg.id === parseInt(values.selectPackage)
                                                            )?.amenities
                                                        }
                                                    </DetailValue>
                                                </CardDetailItem>
                                                <CardDetailItem>
                                                    <DetailLabel>Rent:</DetailLabel>
                                                    <DetailValue>
                                                        ₹
                                                        {
                                                            data?.data?.data?.find(
                                                                (pkg) =>
                                                                    pkg.id === parseInt(values.selectPackage)
                                                            )?.rent
                                                        }
                                                    </DetailValue>
                                                </CardDetailItem>
                                                <CardDetailItem>
                                                    <DetailLabel>Security:</DetailLabel>
                                                    <DetailValue>
                                                        ₹
                                                        {
                                                            data?.data?.data?.find(
                                                                (pkg) =>
                                                                    pkg.id === parseInt(values.selectPackage)
                                                            )?.security || 0
                                                        }
                                                    </DetailValue>
                                                </CardDetailItem>
                                                <CardDetailItem>
                                                    <DetailLabel>No. of Beds Included:</DetailLabel>
                                                    <DetailValue>
                                                        {
                                                            data?.data?.data?.find(
                                                                (pkg) =>
                                                                    pkg.id === parseInt(values.selectPackage)
                                                            )?.totalBedCount
                                                        }
                                                    </DetailValue>
                                                </CardDetailItem>
                                            </CardDetailsList>
                                        </CardContainer>
                                    )}

                                    {isCreatingNew && (
                                        <>
                                            <InputGroup>
                                                <Label htmlFor="title">Title *</Label>
                                                <FieldWrappers>
                                                    <Field
                                                        type="text"
                                                        name="title"
                                                        id="title"
                                                        autoComplete="off"
                                                        required
                                                    />
                                                </FieldWrappers>
                                            </InputGroup>

                                            <CombineInputGroup>
                                                <InputGroup>
                                                    <Label>Sharing Type *</Label>
                                                    <Select
                                                        id="type"
                                                        name="type"
                                                        value={values.type}
                                                        onChange={(e) =>
                                                            setFieldValue("type", e.target.value)
                                                        }
                                                        className="px-2"
                                                        required
                                                        style={{ height: "46px" }}
                                                    >
                                                        {sharingTypes.map((type) => (
                                                            <MenuItem key={type.value} value={type.value}>
                                                                {type.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </InputGroup>
                                                {values.type === 4 && (
                                                    <InputGroup>
                                                        <Label htmlFor="noOfBeds">Number of Beds *</Label>
                                                        <FieldWrappers>
                                                            <Field
                                                                type="number"
                                                                name="noOfBeds"
                                                                id="noOfBeds"
                                                                autoComplete="off"
                                                                min={4}
                                                                max={12}
                                                                value={values.noOfBeds}
                                                                onChange={(e) =>
                                                                    setFieldValue("noOfBeds", e.target.value)
                                                                }
                                                                required
                                                            />
                                                        </FieldWrappers>
                                                    </InputGroup>
                                                )}
                                            </CombineInputGroup>

                                            <InputGroup>
                                                <Label htmlFor="rent">Room Rent *</Label>
                                                <FieldWrappers>
                                                    <RupeeIcon />
                                                    <Field
                                                        type="number"
                                                        name="rent"
                                                        id="rent"
                                                        autoComplete="off"
                                                        required
                                                        className="w-full truncate pl-6"
                                                    />
                                                </FieldWrappers>
                                            </InputGroup>
                                            <InputGroup>
                                                <Label htmlFor="security">Security </Label>
                                                <FieldWrappers>
                                                    <RupeeIcon />
                                                    <Field
                                                        type="number"
                                                        name="security"
                                                        id="security"
                                                        autoComplete="off"
                                                        className="w-full truncate pl-6"
                                                    />
                                                </FieldWrappers>
                                            </InputGroup>

                                            <InputGroup>
                                                <Label>Room Amenities *</Label>
                                                <CardWrapper>
                                                    {amenities.map((mode) => (
                                                        <SelectionCard
                                                            key={mode.value}
                                                            type="button"
                                                            onClick={() => {
                                                                const isSelected = values.amenities.includes(
                                                                    mode.value
                                                                );
                                                                setFieldValue(
                                                                    "amenities",
                                                                    isSelected
                                                                        ? values.amenities.filter(
                                                                            (item) => item !== mode.value
                                                                        )
                                                                        : [...values.amenities, mode.value]
                                                                );
                                                            }}
                                                            className={
                                                                values.amenities.includes(mode.value)
                                                                    ? "bg-[#26A69A] text-white"
                                                                    : "bg-gray-100 text-gray-600"
                                                            }
                                                        >
                                                            <span className="text-sm">{mode.label}</span>
                                                        </SelectionCard>
                                                    ))}
                                                </CardWrapper>
                                            </InputGroup>
                                        </>
                                    )}
                                </Wrapper>
                            </ScrollableContent>

                            <ActionSection className="flex flex-col">
                                <div className="flex justify-between mb-2">
                                    <SideCancelBtn type="button" onClick={handleClose}>
                                        Cancel
                                    </SideCancelBtn>
                                    <SubmitBtn type="submit" disabled={addOptionLoading || addSelectLoading}>
                                        {(addOptionLoading || addSelectLoading) ? "Loading..." : "Submit"}
                                    </SubmitBtn>

                                </div>
                                {!isCreatingNew && (
                                    <NewPackage onClick={() => setIsCreatingNew(true)}>
                                        Create New Package
                                    </NewPackage>
                                )}
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    );
};

const CardWrapper = tw.div`flex flex-wrap gap-2 my-1.5`;
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const NewPackage = tw.button`w-full border border-primary-color items-center mb-2 text-primary-color h-12 rounded-lg hover:bg-primary-color hover:text-white`;
const AddPackageBtn = tw.button`w-full text-base border border-primary-color items-center mb-2 text-primary-color h-10 rounded-lg hover:bg-primary-color hover:text-white`;
const CardContainer = tw.div`mt-4 p-4 border rounded-xl bg-white`;
const CardTitle = tw.h2`text-sm md:text-base font-medium text-blue-600 mb-0`;
const CardDetailsList = tw.ul`space-y-2 text-gray-700`;
const CardDetailItem = tw.li`flex items-center gap-2`;
const DetailLabel = tw.span`text-sm font-medium text-gray-900`;
const DetailValue = tw.span`text-gray-600 text-sm`;
const EditButton = tw.button`text-blue-600 text-sm border border-blue-500 px-2 py-1 flex rounded-lg items-center hover:text-white hover:bg-blue-500`;

export default SelectPackage;
